import React from "react";
import styles from "./modal-table.module.scss";
import UserLogo from "../../../../icons/user.logo";

const mockData = [
  {
    company: "CloudWorks Ltd",
    country: "United Kingdom",
    contactName: "Robin Smit",
    contactInitial: "R",
    contactEmail: "robinsmit@portland.com",
    startDate: "01/11/25",
    endDate: "15/11/25 17:00 UTC",
    status: "Trial",
    daysRemaining: "14 Days",
    conversionDate: null,
    integrations: [
      { name: "NinjaRMM", iconUrl: "/image.png" },
      { name: "ConnectWise Manage", iconUrl: "/avatar-2.png" },
    ],
    devices: "435",
    users: "10",
    tickets: "3",
  },
  {
    company: "Secure Pro",
    country: "United Kingdom",
    contactName: "Robin Smit",
    contactInitial: "R",
    contactEmail: "robinsmit@portland.com",
    startDate: "01/11/25",
    endDate: "15/11/25 17:00 UTC",
    status: "Trial",
    daysRemaining: "14 Days",
    conversionDate: null,
    integrations: [
      { name: "NinjaRMM", iconUrl: "/image.png" },
      { name: "ConnectWise Manage", iconUrl: "/avatar-2.png" },
    ],
    devices: "435",
    users: "10",
    tickets: "3",
  },
  {
    company: "ItNova",
    country: "United Kingdom",
    contactName: "Robin Smit",
    contactInitial: "R",
    contactEmail: "robinsmit@portland.com",
    startDate: "01/11/25",
    endDate: "15/11/25 17:00 UTC",
    status: "Trial",
    daysRemaining: "14 Days",
    conversionDate: null,
    integrations: [
      { name: "NinjaRMM", iconUrl: "/image.png" },
      { name: "ConnectWise Manage", iconUrl: "/avatar-2.png" },
    ],
    devices: "435",
    users: "10",
    tickets: "3",
  },
  {
    company: "Secure Pro",
    country: "United Kingdom",
    contactName: "Robin Smit",
    contactInitial: "R",
    contactEmail: "robinsmit@portland.com",
    startDate: "01/11/25",
    endDate: "15/11/25 17:00 UTC",
    status: "Trial",
    daysRemaining: "14 Days",
    conversionDate: null,
    integrations: [
      { name: "NinjaRMM", iconUrl: "/image.png" },
      { name: "ConnectWise Manage", iconUrl: "/avatar-2.png" },
    ],
    devices: "435",
    users: "10",
    tickets: "3",
  },
  {
    company: "ItNova",
    country: "United Kingdom",
    contactName: "Robin Smit",
    contactInitial: "R",
    contactEmail: "robinsmit@portland.com",
    startDate: "01/11/25",
    endDate: "15/11/25 17:00 UTC",
    status: "Trial",
    daysRemaining: "14 Days",
    conversionDate: null,
    integrations: [
      { name: "NinjaRMM", iconUrl: "/image.png" },
      { name: "ConnectWise Manage", iconUrl: "/avatar-2.png" },
    ],
    devices: "435",
    users: "10",
    tickets: "3",
  },
  {
    company: "ItNova",
    country: "United Kingdom",
    contactName: "Robin Smit",
    contactInitial: "R",
    contactEmail: "robinsmit@portland.com",
    startDate: "01/11/25",
    endDate: "15/11/25 17:00 UTC",
    status: "Trial",
    daysRemaining: "14 Days",
    conversionDate: null,
    integrations: [
      { name: "NinjaRMM", iconUrl: "/image.png" },
      { name: "ConnectWise Manage", iconUrl: "/avatar-2.png" },
    ],
    devices: "435",
    users: "10",
    tickets: "3",
  },
];



const getColumnsForMetric = (metricLabel) => {
  if (!metricLabel) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "trialDays",
      "currentSubscription",
      "integrations",
      "products",
      "services",
      "packages",
    ];
  }

  const label = metricLabel.toLowerCase();

  if (label.includes("new trial")) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "trialDays",
      "currentSubscription",
      "integrations",
      "products",
      "services",
      "packages",
    ];
  }

  if (label.includes("extended trial")) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "currentSubscription",
      "trialDays",
    ];
  }

  if (label.includes("expired trial")) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "currentSubscription",
      "trialDays",
    ];
  }

  if (label.includes("converted")) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "currentSubscription",
      "trialDays",
      "conversionDate",
    ];
  }

  if (label.includes("avg") || label.includes("trial length")) {
    return [
      "companyName",
      "startDate",
      "endDate",
      "currentSubscription",
      "trialDays",
      "conversionDate",
    ];
  }

  // Default fallback
  return [
    "companyName",
    "location",
    "salesRep",
    "startDate",
    "endDate",
    "trialDays",
    "currentSubscription",
  ];
};

const TableRow = ({ data, metric = null }) => {
  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const contactInitial = data.contactInitial || getInitials(data.contactName);
  const metricLabel = metric?.label || "";
  const visibleColumns = getColumnsForMetric(metricLabel);

  return (
    <div className={styles.modalTableRow} role="row">
      {visibleColumns.includes("companyName") && (
        <div className={styles.modalTableCompanySection} role="cell">
          <div className={styles.modalTableAvatarContainer}>
            {data.avatarUrl ? (
              <div
                className={styles.modalTableAvatar}
                style={{ backgroundImage: `url(${data.avatarUrl})` }}
                role="img"
                aria-label={`${data.company} avatar`}
              />
            ) : (
              <UserLogo width="32px" height="32px" fill="#bbbec9"/>
            )}
          </div>
          <div className={styles.modalTableCompanyNameContainer}>
            <div className={styles.modalTableCompanyName} title={data.company}>
              {data.company}
            </div>
          </div>
        </div>
      )}

      {/* Location */}
      {visibleColumns.includes("location") && (
        <div className={styles.modalTableColumnCellWide} role="cell">
          <div className={styles.modalTableColumnText} title={data.country}>
            {data.country}
          </div>
        </div>
      )}


      {visibleColumns.includes("salesRep") && (
        <div className={styles.modalTableSalesRepSection} role="cell">
          <div className={styles.modalTableContactInitialBadge}>
            <div
              className={styles.modalTableContactInitial}
              aria-label={`${data.contactName} initial`}
            >
              {contactInitial}
            </div>
          </div>
          <div className={styles.modalTableContactInfo}>
            <div className={styles.modalTableContactNameRow}>
              <div className={styles.modalTableContactName} title={data.contactName}>
                {data.contactName}
              </div>
            </div>
            <div className={styles.modalTableContactEmail} title={data.contactEmail}>
              {data.contactEmail}
            </div>
          </div>
        </div>
      )}

      {/* Start Date */}
      {visibleColumns.includes("startDate") && (
        <div className={styles.modalTableColumnCellWide} role="cell">
          <div className={styles.modalTableColumnText} title={data.startDate}>
            {data.startDate}
          </div>
        </div>
      )}

      {/* End Date */}
      {visibleColumns.includes("endDate") && (
        <div className={styles.modalTableColumnCellWide} role="cell">
          <div className={styles.modalTableColumnText} title={data.endDate}>
            {data.endDate}
          </div>
        </div>
      )}

      {/* Trial Days */}
      {visibleColumns.includes("trialDays") && (
        <div className={styles.modalTableDaysRemainingColumn} role="cell">
          <div className={styles.modalTableDaysRemainingText} title={data.daysRemaining}>
            {data.daysRemaining}
          </div>
        </div>
      )}

      {/* Current Subscription */}
      {visibleColumns.includes("currentSubscription") && (
        <div className={styles.modalTableStatusColumn} role="cell">
          <div className={styles.modalTableStatusBadge}>
            <div className={styles.modalTableStatusBadgeInner}>
              <span className={styles.modalTableStatusText}>{data.status}</span>
            </div>
          </div>
        </div>
      )}

      {/* Integrations */}
      {visibleColumns.includes("integrations") && (
        <div className={styles.modalTableIntegrationsColumn} role="cell">
          {data.integrations && data.integrations.length > 0 ? (
            data.integrations.map((integration, index) => (
              <div key={index} className={styles.modalTableIntegrationItem}>
                {integration.iconUrl && (
                  <div
                    className={styles.modalTableIntegrationIcon}
                    style={{ backgroundImage: `url(${integration.iconUrl})` }}
                    role="img"
                    aria-label={`${integration.name} icon`}
                  />
                )}
                <div className={styles.modalTableIntegrationName} title={integration.name}>
                  {integration.name}
                </div>
              </div>
            ))
          ) : (
            <div className={styles.modalTableIntegrationName}>—</div>
          )}
        </div>
      )}

      {/* Products */}
      {visibleColumns.includes("products") && (
        <div className={styles.modalTableProductsColumn} role="cell">
          <div className={styles.modalTableColumnText} title={data.devices}>
            {data.devices || "—"}
          </div>
        </div>
      )}

      {/* Services */}
      {visibleColumns.includes("services") && (
        <div className={styles.modalTableServicesColumn} role="cell">
          <div className={styles.modalTableColumnText} title={data.users}>
            {data.users || "—"}
          </div>
        </div>
      )}

      {/* Packages */}
      {visibleColumns.includes("packages") && (
        <div className={styles.modalTablePackagesColumn} role="cell">
          <div className={styles.modalTableColumnText} title={data.tickets}>
            {data.tickets || "—"}
          </div>
        </div>
      )}

      {/* Conversion Date */}
      {visibleColumns.includes("conversionDate") && (
        <div className={styles.modalTableColumnCellWide} role="cell">
          <div className={styles.modalTableColumnText} title={data.conversionDate}>
            {data.conversionDate || "—"}
          </div>
        </div>
      )}
    </div>
  );
};

export const TableBody = ({ data = mockData, metric = null }) => {
  if (!data || data.length === 0) {
    return (
      <div className={styles.modalTableRow} role="row">
        <div className={styles.modalTableColumnText} style={{ padding: "20px", textAlign: "center", width: "100%" }}>
          No data available
        </div>
      </div>
    );
  }

  return (
    <>
      {data.map((rowData, index) => (
        <TableRow key={rowData.id || index} data={rowData} metric={metric} />
      ))}
    </>
  );
};
